<template>
    <div
        v-if="showStockMessage"
        class="stock-message"
        :class="stockMessageClass"
    >
        {{ stockMessage }}
    </div>
</template>

<script>
export default {
    name: "StockLevelMessage",
    props: {
        stockLevels: {
            type: Number,
            default: null
        }
    },
    computed: {
        showStockMessage() {
            return this.stockLevels !== null;
        },
        isOutOfStock() {
            return this.stockLevels === 0;
        },
        isLowStock() {
            return this.stockLevels <= 15;
        },
        isInStock() {
            return this.stockLevels > 15;
        },
        stockMessage() {
            if (this.isOutOfStock) {
                return "Out of stock";
            }
            if (this.isLowStock) {
                return `Only ${this.stockLevels} left`;
            }
            if (this.isInStock) {
                return "In stock";
            }
            return "";
        },
        stockMessageClass() {
            if (this.isOutOfStock) {
                return "out-of-stock";
            }
            if (this.isLowStock) {
                return "low-stock";
            }
            if (this.isInStock) {
                return "in-stock";
            }
            return "";
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../../Presentation/Nop.Web/Themes/MascomTheme/Content/sass/app/variables";

.stock-message {
    padding-bottom: 1rem;
}
.out-of-stock {
    color: $mascom-red;
}
.low-stock {
    color: $mustard;
}
.in-stock {
    color: $mascom-blue;
}
button.disabled {
    opacity: 0.65;
    cursor: not-allowed;
}
</style>
